export type GenericPageBackgroundImagePosition = 'center' | 'top' | 'bottom';

export function normalizeGenericPageBackgroundImagePosition(
  value: unknown,
): GenericPageBackgroundImagePosition {
  if (value === 'top' || value === 'bottom') {
    return value;
  }
  return 'center';
}
